const isIsoDate = (
  date: Scorecards.IsoDate | Scorecards.WeekDate,
): date is Scorecards.IsoDate => {
  return typeof date === 'string';
};

export default isIsoDate;
